import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { Spinner } from '@/components/ui/Spinner'

interface LoadingMessageProps {
  /** Label shown beside the spinner. Defaults to "Loading…". */
  children?: ReactNode
  /** Extra layout classes for the wrapper (e.g. `py-16 justify-center`, `p-4`). */
  className?: string
}

/**
 * Inline spinner + label for in-flight async work. The visible label is the
 * accessible name (`role="status"`), so the decorative Spinner stays hidden.
 * Use a skeleton instead when the content shape is known (see loading-states).
 */
export function LoadingMessage({ children = 'Loading…', className }: LoadingMessageProps) {
  return (
    <div
      role="status"
      className={cn('flex items-center gap-2 text-muted text-sm font-light', className)}
    >
      <Spinner />
      {children}
    </div>
  )
}
